// extracted by mini-css-extract-plugin
export default {"wrapper":"Empty_wrapper__-ytMx","button":"Empty_button__jEvhw"};